import { useQuery } from "@tanstack/react-query";

import { instance } from "@/lib/axios/instance";

export interface CockpitPublicationStatus {
  id?: string;
  name?: string;
  link?: string;
}
/** Publication from Cockpit API (GET by ID). Matches backend GetPublicationByIdResponse. */
export interface CockpitPublicationById {
  id?: string | null;
  title?: string | null;
  remoteId?: string | null;
  jobRequest?: { id?: string } | null;
  status?: CockpitPublicationStatus | null;
  publicationDate?: { start?: string; end?: string } | null;
  descriptions?: {
    summary?: string | null;
    summaryDisplayTitle?: string | null;
    functionDescription?: string | null;
    clientDescription?: string | null;
    requirementsDescription?: string | null;
    offerDescription?: string | null;
    additionalDescription?: string | null;
  } | null;
  preferences?: Record<string, unknown> | null;
  applicationInfo?: Record<string, unknown> | null;
}

export function useCockpitPublicationById(clientId: string | undefined, publicationId: string | undefined) {
  return useQuery({
    queryKey: ["cockpit", "publication", clientId, publicationId],
    queryFn: async (): Promise<CockpitPublicationById | null> => {
      if (!clientId || !publicationId) return null;
      const { data } = await instance.get<CockpitPublicationById>(
        `/api/v2/Integrations/cockpit/job-source/Publications/${encodeURIComponent(publicationId)}`,
        { params: { clientId } }
      );
      return data ?? null;
    },
    enabled: Boolean(clientId && publicationId),
  });
}
